import {inject} from '@angular/core';
import {CanMatchFn, Route} from '@angular/router';
import {OctAuthKeysEnum} from '@core/auth';
import {CookieService} from 'ngx-cookie-service';
import decode from 'jwt-decode';

export const userPermissionGuard: CanMatchFn = (route: Route) => {
  const cookieService = inject(CookieService);
  const permissions = decode(cookieService.get(OctAuthKeysEnum.UserToken)).permissions;

  return permissions.includes(route.data.permission);
};
